"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Document = void 0;
const react_1 = __importDefault(require("react"));
const util_1 = require("./util");
const valid_type_map = {
    base: true,
    link: true,
    title: true,
    meta: true,
    noscript: true,
    script: true,
    style: true,
};
const Document = props => {
    var _a;
    const { children } = props;
    // console.log(children.props.children[0].props.children);
    react_1.default.Children.only(children);
    if (((_a = children === null || children === void 0 ? void 0 : children.type) === null || _a === void 0 ? void 0 : _a.name) !== 'Html') {
        return null;
    }
    const pushChild = [];
    util_1.flattenElements(children, valid_type_map, pushChild);
    return react_1.default.createElement(react_1.default.Fragment, null, pushChild);
};
exports.Document = Document;
//# sourceMappingURL=Document.js.map